module.exports = __webpack_public_path__ + "img/img02.a82ce9bd.png";